export const environment = {
  domain: "https://api.clsedo.com/api",
  serverName: "TULA",
  domainFirebase: 'https://us-central1-deknerd-556e6.cloudfunctions.net',
  rtmpUrl: 'rtmp://stream.nerdof.com/LiveApp',
  streamUrl: 'https://stream.nerdof.com/LiveApp/play.html?name=',
  fileServerEndpoint: 'https://stream.nerdof.com/api'
}